import React, { useEffect, useState } from 'react';
import LoginForm from '../components/auth/LoginForm';
import fullLogoSrc from '../../assets/images/fullLogo.png';
import { useAuth } from '../../wms/context/wms-context';
import { useNavigate } from 'react-router-dom';
import config from '../../utils/config';
import loginBackground from '../../assets/images/loginBackground.png';
import { resolveDefaultTaskRoute, loadWmsMenuTree } from '../utils/wms-menu';

export default function WMS_LOGIN() {
    const ORIGIN = config.origin;
    const { login } = useAuth();
    const history = useNavigate();
    const [userAuthError, setUserAuthError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [serverError, setServerError] = useState(false);
    const ssoToken = new URLSearchParams(window.location.search).get('ssoToken');
    // const useTraditionalLogin = new URLSearchParams(window.location.search).get('bytrek');
    const ssoFail = new URLSearchParams(window.location.search).get('ssoFail');

    useEffect(() => {
        if (ssoToken) {
            setPageLoading(true);
            sendData();
        }
    }, [ssoToken]);

    useEffect(() => {
        if (ssoFail) {
            setServerError(true);
        }
    }, [ssoFail]);

    const createUserLogin = async (data) => {
        await loadWmsMenuTree();
        login(data);
        history(resolveDefaultTaskRoute(data.permissions || [], data.defaultTask || ''));
    };

    const sendData = async (data) => {
        try {
            const response = await fetch(`${ORIGIN}/wms/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userEmail: data?.email,
                    password: data?.password,
                    ssoToken,
                }),
            });

            if (response.ok) {
                const result = await response.json();
                await createUserLogin(result);
            } else {
                setServerError(true);
            }
        } catch (error) {
            setServerError(true);
        } finally {
            setIsLoading(false);
            setPageLoading(false);
        }
    };

    const jumpcloudLogin = () => {
        window.location.href = `${ORIGIN}/wms/login/saml`;
    };

    return (
        <>
            <div className='flex flex-row-reverse min-h-screen'>
                <LoginForm
                    submitData={sendData}
                    userAuthError={userAuthError}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setUserAuthError={setUserAuthError}
                    serverError={serverError}
                    pageLoading={pageLoading}
                    jumpcloudLogin={jumpcloudLogin}
                    // useTraditionalLogin={useTraditionalLogin}
                    useTraditionalLogin={false}
                />
                <div className='hidden relative flex-1 w-0 lg:block'>
                    <img className='object-cover absolute inset-0 w-full h-full' src={loginBackground} alt='' />
                    <img
                        className='object-contain absolute top-10 right-24 w-3/5 h-auto'
                        width={780}
                        src={fullLogoSrc}
                        alt=''
                    />
                </div>
            </div>
        </>
    );
}
